import React, { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import DatePicker from 'react-datepicker'
import {
  selectCustomEmailFilter,
  selectEmailFilterAfter,
  selectEmailFilterBefore,
  selectShowEmailFilterModal,
  setEmailFilterAfter,
  setEmailFilterBefore,
} from '../../store/emailHub/emailFilters'
import { useFetchEmailThreads } from '../../views/EmailV2/hooks'
import { selectEmailThreadsLoading } from '../../store/emailHub/emailThreads'

const twoMonthsAgo = () => {
  const date = new Date()
  date.setMonth(date.getMonth() - 2)
  return date
}

export interface EmailDateFilterProps {
  disabled?: boolean
}

export const EmailDateFilter: React.FC<EmailDateFilterProps> = ({ disabled = false }) => {
  const dispatch = useAppDispatch()
  const emailFilterBefore = useAppSelector(selectEmailFilterBefore)
  const emailFilterAfter = useAppSelector(selectEmailFilterAfter)
  const showEmailFilterModal = useAppSelector(selectShowEmailFilterModal)
  const customFilter = useAppSelector(selectCustomEmailFilter)
  const emailThreadsLoading = useAppSelector(selectEmailThreadsLoading)

  const { fetchEmailThreads } = useFetchEmailThreads()

  const [startDate, setStartDate] = useState<Date | null>(null)
  const [endDate, setEndDate] = useState<Date | null>(null)

  useEffect(() => {
    if (emailFilterAfter) {
      setStartDate(new Date(emailFilterAfter))
      setEndDate(emailFilterBefore ? new Date(emailFilterBefore) : new Date())
    } else {
      setStartDate(null)
      setEndDate(null)
    }
  }, [emailFilterAfter, emailFilterBefore])

  const handleDateFilterChanged = async (update: [Date | null, Date | null]) => {
    const [currentStartDate, currentEndDate] = update
    currentEndDate?.setHours(23, 59, 59, 999)
    setStartDate(currentStartDate)
    setEndDate(currentEndDate)
    if (currentStartDate && currentEndDate) {
      dispatch(setEmailFilterAfter(currentStartDate.toISOString()))
      dispatch(setEmailFilterBefore(currentEndDate.toISOString()))
      if (!showEmailFilterModal) {
        await fetchEmailThreads({ filter: { ...customFilter, after: currentStartDate.toISOString(), before: currentEndDate.toISOString() } })
      }
    } else if (!currentStartDate && !currentEndDate) {
      dispatch(setEmailFilterAfter(null))
      dispatch(setEmailFilterBefore(null))
    }
  }

  return (
    <div className='d-flex flex-column gap-1'>
      <div className='lead-extra-small'>Filter by date {startDate && endDate ? '(1)' : null}</div>
      <DatePicker
        wrapperClassName='w-100'
        className='form-control zocks-border-color-gray-400'
        selectsRange={true}
        minDate={twoMonthsAgo()}
        maxDate={new Date()}
        startDate={startDate}
        endDate={endDate}
        onChange={handleDateFilterChanged}
        isClearable={true}
        placeholderText='Choose date'
        showIcon={!startDate && !endDate}
        toggleCalendarOnIconClick
        icon='bi bi-calendar4-week'
        calendarIconClassname='email-filter-calendar-icon'
        disabled={emailThreadsLoading || disabled}
      />
    </div>
  )
}
